export const ROLES = {
    ADMIN: 'admin',
    ARTIST: 'artist',
    COLLECTOR: 'collector',
    TEAM: 'team',
    COLLABORATOR: 'collaborator',
  };